import { deleteSessionStorage } from 'eds-common';
import { meResponseShape } from 'eds-common/api/v2';

export const switchOrganization = async (orgId: string) => {
  const response = await fetch(`/api/auth/v2/me?switch-org-id=${orgId}`);
  if (!response.ok) {
    throw new Error('Failed to switch organization');
  }
  return meResponseShape.parse(await response.json());
};

/**
 * Initiates the sign out process for the current user.
 *
 * This function makes an API call to the logout endpoint and
 * evaluates the response. If the response status code is within
 * the successful range (200-399), it returns true, indicating
 * that the sign out was likely successful. Otherwise, it returns
 * false.
 *
 * @returns {Promise<boolean>} A promise that resolves to a boolean
 * indicating whether the sign out was successful.
 */
export async function signOut(timeout: boolean = false) {
  const apiUrl = timeout
    ? '/api/auth/v2/user/logout?state=TimedOut'
    : '/api/auth/v2/user/logout';
  const response = await fetch(apiUrl);
  if (response.status >= 400) {
    throw new Error('Failed to sign out');
  } else {
    deleteSessionStorage('SELECTED_GRADE_SECTION');
  }
}

export async function extendSession() {
  const response = await fetch('/api/auth/v2/user/extend');
  if (response.status >= 400) {
    throw new Error('Failed to extend session');
  }
  return null;
}
